import { useMemo } from 'react';

// Maps ListView moduleName values to menuPermission object keys from the login API.
const MODULE_PERMISSION_MAP = {
  jobs: 'job',
  job: 'job',
  candidates: 'candidates',
  candidate: 'candidates',
  submissions: 'submissions',
  submission: 'submissions',
  vendors: 'vendors',
  vendor: 'vendors',
  campaign: 'campaingns',
  campaigns: 'campaingns',
  hotlist: 'hotlist',
  network: 'network',
  onboarding: 'onboarding',
};

function readRawPermission(moduleName) {
  try {
    const raw = localStorage.getItem('menuPermission');
    if (!raw || !moduleName) return {};
    const all = JSON.parse(raw);
    if (!all || typeof all !== 'object') return {};
    const normalized = String(moduleName).trim().toLowerCase();
    const key = MODULE_PERMISSION_MAP[normalized] ?? normalized;
    return all[key] ?? {};
  } catch {
    return {};
  }
}

// Permission values come as 1/0 integers from the API.
// Absent key → default allow (no config = unrestricted).
function isAllowed(value) {
  if (value === undefined || value === null) return true;
  return Number(value) !== 0 && value !== false && value !== '0';
}

export function useMenuPermission(moduleName) {
  return useMemo(() => {
    const p = readRawPermission(moduleName);
    return {
      canView:   isAllowed(p.view),
      canAdd:    isAllowed(p.add),
      canEdit:   isAllowed(p.edit),
      canDelete: isAllowed(p.delete),
    };
  }, [moduleName]);
}
